import { dialog, InputJson, toDisplayCase } from "nq-component";
import {
  getObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import withRouter from "../../../../../withRouter";
import BaseFormPage from "../../../../../base/BaseFormPage";
import NavBar from "../../../../../components/navbar";
import FormFactory from "../../../../../components/FormFactory";
import DialogModal from "../../../../../components/Dialog";
import StockRequestFormPresenter from "./StockRequestFormPresenter";
import DialogTable from "../../../../../components/DialogTable";
import BreakdownTable from "../../../../../components/BreakdownTable";

class StockRequestFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = { object: {}, advanced: false, selectedRawIds: [] };
    this.presenter = new StockRequestFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "stock_requests";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  handleOpenRaw() {
    const schema = this.getSchema("raw_materials");
    const user = this.getCurrentUser();
    const hasAdminRole = user?.roles?.some((role) => role.id === "Admin");
    const storeId = user?.storeAnalytic?.[0]?.id;
    dialog.fire({
      html: (
        <DialogTable
          title="raw_materials"
          where={{}}
          schema={schema}
          onCancel={() => dialog.close()}
          onSelect={(selectedItems) => {
            this.setState((prev) => {
              const existing = prev.object.raw_materials || [];

              console.log("exxx", existing);

              const mergedMap = new Map();
              for (const item of existing) {
                mergedMap.set(item.id, item);
              }

              for (const item of selectedItems) {
                const existingItem = mergedMap.get(item.id);
                mergedMap.set(item.id, {
                  ...item,
                  quantity: existingItem?.quantity || item.quantity || "",
                });
              }

              return {
                object: {
                  ...prev.object,
                  raw_materials: Array.from(mergedMap.values()),
                },
              };
            });
          }}
        />
      ),
      footer: false,
    });
  }

  handleDeleteSelected() {
    const { selectedRawIds, object } = this.state;
    const updated = (object.raw_materials || []).filter(
      (item) => !selectedRawIds.includes(item.id)
    );

    this.setState({
      object: {
        ...object,
        raw_materials: updated,
      },
      selectedRawIds: [], // reset after delete
    });
  }

  onChange(value, field) {
    if (field === "remarks") {
      const hasValue = value !== undefined && value !== null && value !== "";
      this.setState({ hasRemarks: hasValue });
    }

    this.presenter.onChange(value, field);
  }

  handleSelectAll = (e) => {
    const checked = e.target.checked;
    const allIds = (this.state.object.raw_materials || []).map(
      (item) => item.id
    );
    this.setState({
      selectedRawIds: checked ? allIds : [],
    });
  };

  handleSelectOne = (e, id) => {
    const { selectedRawIds } = this.state;
    const updated = e.target.checked
      ? [...selectedRawIds, id]
      : selectedRawIds.filter((itemId) => itemId !== id);
    this.setState({ selectedRawIds: updated });
  };

  handleChangeQuantity = (e, index) => {
    const value = e.target.value;
    console.log("value", value);
    if (this.state.object?.id) {
      const updatedMaterials = [...(this.state.object.items || [])];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        quantity: value,
      };

      this.setState((prev) => ({
        object: {
          ...prev.object,
          raw_materials: updatedMaterials,
        },
      }));
      console.log("ooo h", this.state.object);
    } else {
      const updatedMaterials = [...(this.state.object.raw_materials || [])];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        quantity: value,
      };

      this.setState((prev) => ({
        object: {
          ...prev.object,
          raw_materials: updatedMaterials,
        },
      }));
    }
  };

  handleChangeQuantityPartial = (e, index) => {
    const value = e.target.value;
    console.log("value", value);
    if (this.state.object?.id) {
      const updatedMaterials = [...(this.state.object.items || [])];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        quantityReceive: value,
      };

      this.setState((prev) => ({
        object: {
          ...prev.object,
          items: updatedMaterials,
        },
      }));
      console.log("ooo h", this.state.object);
    } else {
      const updatedMaterials = [...(this.state.object.raw_materials || [])];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        quantity: value,
      };

      this.setState((prev) => ({
        object: {
          ...prev.object,
          raw_materials: updatedMaterials,
        },
      }));
    }
  };
  // handleChangeQuantity = (e, index) => {
  //   const value = e.target.value;

  //   const updatedMaterials = [...(this.state.object.raw_materials || [])];

  //   // Clone the object fully
  //   const updatedItem = { ...updatedMaterials[index] };

  //   // Avoid reference mutation
  //   updatedItem.quantity = value;

  //   updatedMaterials[index] = updatedItem;

  //   this.setState((prev) => ({
  //     object: {
  //       ...prev.object,
  //       raw_materials: updatedMaterials,
  //     },
  //   }));
  // };

  handleChangeQuantity2 = (e, index) => {
    const input = e.target.value; // string
    this.setState((prev) => {
      // pick the same array your table uses
      const usesRaw = Array.isArray(prev.object?.raw_materials);
      const src = usesRaw ? prev.object.raw_materials : prev.object.items || [];

      const rows = [...src];
      const row = { ...rows[index] };

      // allow blank while typing
      if (input === "") {
        row.quantityReceivePartial = "";
      } else {
        const maxQty = Number(row.quantity ?? Infinity);
        const next = Math.max(0, Math.min(Number(input), maxQty));
        row.quantityReceivePartial = Number.isFinite(next) ? next : 0;
      }

      rows[index] = row;

      const nextObj = { ...prev.object };
      if (usesRaw) nextObj.raw_materials = rows;
      else nextObj.items = rows;

      return { object: nextObj };
    });
  };

  // handleChangeQuantity2 = (e, index) => {
  //   const value = e.target.value;
  //   console.log("vl", value);
  //   const updatedMaterials = [...(this.state.object.items || [])];
  //   updatedMaterials[index] = {
  //     ...updatedMaterials[index],

  //     quantityReceivePartial: value,
  //   };

  //   this.setState((prev) => ({
  //     object: {
  //       ...prev.object,
  //       items: updatedMaterials,
  //     },
  //   }));
  // };
  render() {
    const object = this.state.object;
    const params = this.getParams();
    console.log("object", object);
    console.log("pa", params);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Edit ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="d-flex justify-content-between align-items-center">
                <h2
                  className="fw-bold mt-3 text-capitalize"
                  style={{ color: "#82c14a" }}
                >
                  <i
                    onClick={() => this.navigateBack()}
                    className="bi bi-chevron-compact-left"
                    style={{ color: "black", cursor: "pointer" }}
                  ></i>
                  {object?.id
                    ? params.view + " Items"
                    : label +
                      (schema.label || toDisplayCase(this.getCollectionName()))}
                </h2>

                {object?.id && (
                  <span
                    className="px-3 py-1 fw-semibold"
                    style={{
                      backgroundColor: "#ffcd29", // yellow
                      borderRadius: "999px",
                      color: "#212529", // dark text
                      fontSize: "0.875rem",
                      border: "1px solid #d6a500",
                    }}
                  >
                    {object?.status}
                  </span>
                )}
              </div>

              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                <h6>Details</h6>
                <hr />
                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {params?.view === "reconcile" && (
                          <p className="mb-0">
                            Store: {object?.sourceLocation?.name}
                          </p>
                        )}
                        {params?.view === "reconcile" ? (
                          // ✅ Always show FormFactory when reconcile
                          <FormFactory
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={[
                              "raw_materials",
                              "cost",
                              "requestNumber",
                              "status",
                              "requestDate",
                              "requestedBy",
                              "destinationLocation",
                              "items",
                              "sourceLocation",
                              "remarks",
                            ]}
                          />
                        ) : object?.id ? (
                          <>
                            {params?.view === "view" && (
                              <div
                                style={{
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                  padding: "16px",
                                  marginTop: "12px",
                                }}
                              >
                                <h6
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "8px",
                                  }}
                                >
                                  Details
                                </h6>
                                <hr
                                  style={{ marginTop: 0, marginBottom: "16px" }}
                                />
                                <div
                                  style={{ lineHeight: "1.8", color: "#333" }}
                                >
                                  <div>
                                    <strong>Store :</strong>{" "}
                                    {object?.sourceLocation?.name}
                                  </div>
                                  <div>
                                    <strong>Est. Delivery Time :</strong>{" "}
                                    {object?.estimatedDeliveryTime &&
                                      new Date(
                                        object.estimatedDeliveryTime
                                      ).toLocaleString("en-PH", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                        timeZone: "Asia/Manila",
                                      })}
                                  </div>
                                  <div>
                                    <strong>Delivery Time :</strong>{" "}
                                    {object?.deliveryTime &&
                                      new Date(
                                        object?.deliveryTime
                                      ).toLocaleString("en-PH", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                        timeZone: "Asia/Manila",
                                      })}
                                  </div>
                                  <div>
                                    <strong>Remarks :</strong> {object?.remarks}
                                  </div>
                                </div>
                              </div>
                            )}
                            {(params?.view === "receive" ||
                              params?.view === "partial") && (
                              <div
                                style={{
                                  backgroundColor: "#f5f5f5",
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                  padding: "16px",
                                  marginTop: "12px",
                                }}
                              >
                                <h6
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "8px",
                                  }}
                                >
                                  Details
                                </h6>
                                <hr
                                  style={{ marginTop: 0, marginBottom: "16px" }}
                                />
                                <div
                                  style={{ lineHeight: "1.8", color: "#333" }}
                                >
                                  <div>
                                    <strong>Store :</strong>{" "}
                                    {object?.sourceLocation?.name}
                                  </div>
                                  <div>
                                    <strong>Request Date :</strong>{" "}
                                    {object?.requestDate &&
                                      new Date(
                                        object?.requestDate
                                      ).toLocaleString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                        hour: "numeric",
                                        minute: "2-digit",
                                        hour12: true,
                                      })}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        ) : (
                          // Default form for new objects
                          <FormFactory
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={[
                              "raw_materials",
                              "cost",
                              "requestNumber",
                              "status",
                              "requestDate",
                              "requestedBy",
                              "destinationLocation",
                              "items",
                            ]}
                            disabled={!!object?.id}
                          />
                        )}
                      </>
                    )}
                  </div>

                  {params?.view !== "receive" && params?.view !== "partial" && (
                    <BreakdownTable
                      title={
                        object?.status === "Pending"
                          ? "Items"
                          : object?.status === "Approved"
                          ? "Requested Items"
                          : "Requested Items"
                      }
                      data={object.items || object.raw_materials}
                      selectedIds={this.state.selectedRawIds}
                      onSelectAll={this.handleSelectAll}
                      onSelectOne={this.handleSelectOne}
                      onChange={this.handleChangeQuantity}
                      onAdd={() => this.handleOpenRaw()}
                      onDelete={() => this.handleDeleteSelected()}
                      disableAdd={!this.state.hasRemarks && !this.getObjectId()}
                      hasQuantity={
                        this.state.hasRemarks || !!this.getObjectId()
                      }
                      showUOM={false}
                      disableQty={false}
                      checkbox={object?.id ? false : true}
                      // showQuantityApprove={params?.partial ? true : false}
                      showAddButton={object.id ? false : true}
                    />
                  )}

                  {[
                    "Approved",
                    "Dispatched",
                    "Pending Fully Received",
                    "Completed",
                    "Partially Received",
                    "Disapproved",
                    "For Reconciliation",
                  ].includes(object?.status) && (
                    <BreakdownTable
                      title={
                        object.status === "Disapproved"
                          ? "Actual Item Received"
                          : "Approved Items"
                      }
                      data={
                        object.raw_materials ||
                        (object.items || []).map((item) => ({
                          ...item,
                          quantity:
                            item.remainingQty ||
                            item.quantityReceive ||
                            item.quantityApprove, // override for display
                          quantityReceivePartial: item.quantityReceivePartial,
                        }))
                      }
                      selectedIds={this.state.selectedRawIds}
                      onSelectAll={this.handleSelectAll}
                      onSelectOne={this.handleSelectOne}
                      onChange={this.handleChangeQuantityPartial}
                      onChange2={this.handleChangeQuantity2}
                      onAdd={() => this.handleOpenRaw()}
                      onDelete={() => this.handleDeleteSelected()}
                      disableAdd={!this.state.hasRemarks && !this.getObjectId()}
                      hasQuantity={
                        this.state.hasRemarks || !!this.getObjectId()
                      }
                      showUOM={false}
                      disableQty={
                        params.view === "partial" || params.view === "receive"
                      }
                      checkbox={object?.id ? false : true}
                      // showQuantityApprove={
                      //   params.view === "partial" ? true : false
                      // }
                      showQuantityReceivePartial={
                        params.view === "partial" ? true : false
                      }
                      disableQtyApprove={false}
                      showAddButton={false}
                    />
                  )}

                  <div className="mt-4 text-center">
                    {params?.view !== "view" ? (
                      <>
                        <button
                          type="button"
                          className="btn fs-sm w-25"
                          onClick={this.onClickBack.bind(this)}
                          style={{ backgroundColor: "#d1d1d1" }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn fs-sm text-white ms-3 w-25"
                          style={{ backgroundColor: "#82c14a" }}
                        >
                          <i className="bi text-white bi-file-earmark-check me-2"></i>
                          Submit
                        </button>
                      </>
                    ) : (
                      object?.id && (
                        <button
                          type="button"
                          className="btn fs-sm w-50 text-white"
                          onClick={this.onClickBack.bind(this)}
                          style={{ backgroundColor: "#82c14a" }}
                        >
                          Back
                        </button>
                      )
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(StockRequestFormPage);
